<template>
  <CustomerName :customer="profile" class="gmf-customer-name" />
</template>

<script>
import state from '@/state';
import CustomerName from '@/components/CustomerName.vue';

export default {
  components: {
    CustomerName,
  },
  name: 'MyCustomerName',
  data () {
    return {
      state,
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    }
  },
};
</script>
